<template>
	<v-card flat tile>
		<v-card-text>
			<v-container>
        <v-row> 
          <v-col cols="4" class="s-col-form">
            <s-date v-model="ins.InsDate" />
          </v-col>
          <v-col cols="4" class="s-col-form">
            <s-select-definition 
                label="Tipo Evento"
                :def="1067" 
                v-model="ins.TypeInstruction"
              />
          </v-col>
          <v-col cols="4" class="s-col-form">
            <s-select-campaign-se 
                label="Campaña"
                v-model="ins.CmpID"
              />
          </v-col>
          <v-col cols="2" class="s-col-form" v-if="ins.TypeInstruction==2">
            <s-select-definition 
                label="Modalidad"
                :def="1459" 
                v-model="ins.TypeModality"
              />
          </v-col>
          <v-col cols="2" class="s-col-form" v-if="ins.TypeInstruction==2">
            <s-select-definition 
                label="Tipo de Costo"
                :def="1460" 
                v-model="ins.TypeCost"
              />
          </v-col>
          <v-col cols="2" class="s-col-form" v-if="ins.TypeInstruction==2 && ins.TypeCost == 2">
            <s-text label="Monto de Costo" v-model.number="ins.AmountCost"   decimal/>
          </v-col> 
          <v-col cols="2" class="s-col-form" v-if="ins.TypeInstruction==2 && ins.TypeCost == 2">
            <s-select-definition 
                label="Moneda"
                :def="1129" 
                v-model="ins.TypeCurrency"
              />
          </v-col>
          
          <!-- <v-col cols="2" class="s-col-form" v-if="ins.TypeInstruction==2">
            <s-select-definition 
                label="Protocolo"
                :def="1461" 
                v-model="ins.TypeProtocol"
                :add="$fun.isAdmin()"
              />
          </v-col>  -->
          <v-col cols="12" md="5" class="s-col-form" v-if="ins.TypeInstruction==2 && ins.InsTypeCapacitor == 2">
            <!-- <s-select-definition 
                label="Gerencia(usuario)"
                :def="1466" 
                v-model="ins.TypeGerency"
                :add="$fun.isAdmin()"
              /> -->
              <v-label><b>Centro de Costo</b></v-label>
              <v-autocomplete
										v-model="centerCostModel"
										:items="itemsCenterCost"
										hide-details
										dense
										multiple
										clearable
                    chips
                    deletable-chips
										solo
										class="autocompleteQuery"
									></v-autocomplete>
          </v-col> 
          <v-col cols="12" md="3" class="s-col-form" v-if="ins.TypeInstruction==2">
            <s-select-definition 
                label="Tipo Capacitor"
                :def="1559" 
                v-model="ins.InsTypeCapacitor"
                :add="$fun.isAdmin()"
              />
          </v-col>
          <v-col cols="12" md="3" class="s-col-form" v-if="ins.TypeInstruction==2">
            <s-select-definition 
                label="Sitio"
                :def="1560" 
                v-model="ins.InsTypeCapacitor"
                :add="$fun.isAdmin()"
              />
          </v-col>
          <v-col class="s-col-form">
            <s-text label="Observaciones" v-model="ins.InsObservation" />
          </v-col> 
          <v-col class="s-col-form d-flex align-end" cols="1">
            <v-btn color="success" :disabled="false" small @click="openCamera()"><v-icon>mdi-camera</v-icon></v-btn>
          </v-col>
        </v-row>
				<v-row>
					<v-col cols="12" md="6">
						
						<s-crud
							title="Capacitores"
							noDark
							formPermanent
							ref="crudInstruction"
							add
							edit
							remove
							noSearch
							noBorder
							:filter="filter"
							:config="iinConfig"
							@save="iinSave"
							@returnObject="returnObjectIin"
							class="py-0 mt-0 mb-n2"
							noConfimationSave
							noFooter
              @rowSelected="rowSelected($event)"
						>
						<template slot-scope="props">
							<v-container>
								<v-row class="mt-n3">
									<v-col cols="9" class="s-col-form">
										<s-toolbar-subject
											ref="tbIinSubject"
											add
											v-model="props.item.IsbID"
											@returnSubject="iinReturnSubject($event, props.item)"
                      clearable
										/>
									</v-col>
									<v-col cols="3" class="s-col-form">
										<s-text
											label="Duración (min)"
											number
											:min="min"
                      v-model="props.item.IinDurationTime"
                      readonly
										></s-text>
									</v-col>
									<!-- <v-col cols="3" class="s-col-form">
										<s-select-definition
											readonly
											:def="1067"
											v-model="props.item.TypeInstruction"
											label="Tipo"
										/>
									</v-col> -->
								</v-row>
								
								<v-row>
									<v-col cols="4" class="s-col-form">
										<!-- <s-text
											label="DNI"
											v-model="props.item.PrsDocumentNumber"
											@keyupEnter="keyUpEnter($event)"
										>
										</s-text> -->

                    <s-toolbar-person
                      ref="DNI"
                      v-model="props.item.PrsDocumentNumber"
                      @returnPerson="keyUpEnter($event, props.item)"
                      :autofocus="false"
                      type="text"
                      />
									</v-col>
									<v-col cols="8" class="s-col-form">
										<s-text
											label="Capacitador"
											v-model="NtpName"
											:readonly="hasWorker"
										/>
									</v-col>
                  <v-col cols="12" v-if="ins.InsTypeCapacitor == 2" class="s-col-form">
                    <s-text v-model="props.item.NameCompanyCapacitor" label="Empresa" clearable></s-text>
                  </v-col>
                  <v-col cols="6" v-if="ins.InsTypeCapacitor == 2" class="s-col-form">
                    <s-load v-model="fileCapacitor.CvCompanyCapacitor" label="CV" clearable></s-load>
                  </v-col>
                  <v-col cols="6" v-if="ins.InsTypeCapacitor == 2" class="s-col-form">
                    <s-load v-model="fileCapacitor.InformeCompanyCapacitor" label="Informe" clearable></s-load>
                  </v-col>
								</v-row>

                <v-row>
                  <v-col>
                    <s-textarea label="Observaciones" v-model="props.item.IObservation"></s-textarea>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="6">
                    <s-text
                      type="time"
                      label="Hora Inicio"
                      v-model="props.item.IInicioTime"
                      :disabled="props.item.IinDurationTime == null || props.item.IinDurationTime === ''"
                      @input="calcularHoraFin(props.item)"
                    />
                  </v-col>
                  <v-col cols="6">
                    <s-text type="time" label="Hora Fin" v-model="props.item.IFinTime" disabled></s-text>
                  </v-col>
                </v-row>

								<!-- <v-row>
									<v-col cols="4" class="s-col-form">
										<s-toolbar-person
											ref="tbIinPerson"
											v-model="props.item.PrsDocumentNumber"
											@returnPerson="iinReturnPerson($event, props.item)"
											:autofocus="false"
										/>
									</v-col>
									<v-col cols="8" class="s-col-form">
										<s-text
											disabled
											label="Encargado"
											v-model="props.item.NtpFullName"
										/>
									</v-col>
								</v-row> -->
							</v-container>
						</template>
						</s-crud>
					</v-col>
					<v-col cols="12" md="6">
            <s-toolbar label="Asistencia por Capacitador" dark color="#8e8f91"></s-toolbar>
            <v-data-table
              :headers="iasConfig.headers"
              :items="itemsCapacitor"
              dense
            >

            </v-data-table>
          </v-col>
				</v-row>
        <v-row>
          <v-col cols="12">
						<v-card>
						<s-crud
							title="Asistencia"
							formPermanent
							ref="crudAttendance"
							noDark
							add
							edit
							excel
							remove
							noSearch
							noBorder
							:filter="filter"
							:config="iasConfig"
							@save="iasSave"
							@rowSelected="rowSelectedAttendance($event)"
							class="py-0 my-0"
							noConfimationSave
              :single-row="false"
              :itemsPerPage="[-1]"
						>
							<template slot-scope="props">
							<v-container>
								<v-row class="mt-n3">
								<v-col cols="4" class="s-col-form">
									<s-toolbar-person
									ref="tbIasPerson"
									v-model="props.item.PrsDocumentNumber"
									@returnPerson="iasReturnPerson($event, props.item)"
									:autofocus="false"
                  type="text"
									/>
								</v-col>
								<v-col cols="8" class="s-col-form">
									<s-text
									 
									label="Asistente"
									v-model="props.item.NtpFullName"
									/>
								</v-col>
								</v-row>
                <v-row>
                  <!-- <v-col sm="4">
                    <s-select-definition 
                      label="Tipo Trabajador"
                      :def="1039"
                      :dgr="4"
                      clareable
                      v-model="TypeWorker"
                    />
                  </v-col> -->
                
                  <v-col sm="6">
                      <s-select-area  
                        v-if="selectAreName"
                        label="Area*"  
                        :text="props.item.AreName"
                        v-model="AreID"
                       />
                  </v-col>
                
                </v-row>
							</v-container>
							</template>
						</s-crud>
            <v-row>
              <v-col>
                <v-btn @click="saveAttendance" :disabled="itemCapacitor?.NtpFullName? false : true" block color="success"><v-icon>mdi-content-save</v-icon>&nbsp;Guardar asistencia para : {{ itemCapacitor?.NtpFullName }}</v-btn>
              </v-col>
            </v-row>
						</v-card>
					</v-col>
        </v-row>
			</v-container>
		</v-card-text>

    <v-dialog v-model="dialogInduction" transition="dialog-bottom-transition" max-width="900px">
      <v-card>
        <s-toolbar label="Lista de Inducciones del Trabajador" close @close="dialogInduction = false" dark color="#8e8f91"></s-toolbar>
        <v-container>
          <template>
            <v-timeline>
              <v-timeline-item
                v-for="(item, i) in itemsInduction"
                :key="i"
                large
              >
                <!-- <template v-slot:icon>
                  <v-avatar>
                    <img src="https://i.pravatar.cc/64">
                  </v-avatar>
                </template> -->
                <template v-slot:opposite>
                  <h5 style="color: red;">Capacitador:</h5>
                  <h4>{{ item.IinNamePerson }}</h4>
                  <p>{{ $fun.formatDateView(item.InsDate) }}</p>
                </template>
                <v-card class="elevation-2">
                  <v-card-title class="text-h5" style="display: flex;">
                    <span><b style="color: red; font-weight: bold;">Tema : </b>{{ item.IsbSubject }}</span>
                  </v-card-title>
                  <v-card-text>{{ item.IsbDescription }}</v-card-text>
                </v-card>
              </v-timeline-item>
            </v-timeline>
          </template>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogCamera" transition="dialog-bottom-transition" max-width="900px">
      <v-card>
        <s-toolbar label="Evidencias" close @close="dialogCamera = false" dark color="#8e8f91" save @save="saveEvidence(InsIDCamera)"></s-toolbar>
        <v-container>
          <v-row>
            <v-col cols="6">
              <s-load type="file" img label="Evidencia 1 (Solo Imagenes)" v-model="itemAnexo1"></s-load>
            </v-col>
            <v-col cols="6">
              <s-load type="file" img label="Evidencia 2 (Solo Imagenes)" v-model="itemAnexo2"></s-load>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <img
                :src="itemAnexo1DB"
                alt=""
                style="width: 100%; height: 300px; object-fit: contain; border: 1px solid #ccc;"
              />
            </v-col>
            <v-col cols="6">
              <img
                :src="itemAnexo2DB"
                alt=""
                style="width: 100%; height: 300px; object-fit: contain; border: 1px solid #ccc;"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
	</v-card>
</template>

<script>
import _sInstruction from "@/services/Management/InstructionService";
import _sInstructionInstructor from "@/services/Management/InstructionInstructorService";
import _sInstructionAttendance from "@/services/Management/InstructionAttendanceService";
import sToolbarPerson from "@/components/Utils/Person/sToolbarPerson";
import sToolbarSubject from "@/views/Management/Instruction/SToolbarSubject.vue";

import _sPerson from '@/services/General/PersonService';
import _sSunarp from "@/services/General/SearchSunarp.js"
import GenUploadFiles from "../../../services/General/GenUploadFiles";

export default {
  components: {
    sToolbarPerson,
    sToolbarSubject,
  },
  props: {
    value: {
      default: {
        InsDate: "",
        InsObservation: "",
        InsID: 0,
      },
      required: true,
    },
  },
  data() {
    return {
      IinIDSave: 0,
      fileCapacitor: {
        CvCompanyCapacitor: [],
        InformeCompanyCapacitor: []
      },
      itemAnexo1: null,
      itemAnexo2: null,
      itemAnexo1DB: null,
      itemAnexo2DB: null,
      InsIDCamera: 0,
      dialogCamera: false,
      itemsCenterCost: [],
      dialogInduction: false,
      itemsInduction: [],
      itemsCapacitor: [],
      itemCapacitor: {},
      selectedAttendance: [],
      selectAreName: true,
      TypeWorker: '',
      AreID: '',
		NtpName : "",
		NtpPerson: {},
		hasWorker : false,
    worker : {},
		min: 1,
      ins: {
        InsDate: "",
        InsObservation: "",
        InsID: 0,
        TypeInstruction: 1,
      },
      iinConfig: {
        service: _sInstructionInstructor,
        model: {
          InsID: "int",
          IinID: "ID",
          NtpID: "int",
          PrsDocumentNumber: "string",
          NtpFullName: "string",
          WkrID: "int",
          IsbSubject: "string",
          SecStatus: "status",
        },
        headers: [
          {
            text: "ID",
            value: "IinID",
          },
          {
            text: "Instructor",
            value: "IinNamePerson",
          },
          {
            text: "Tema",
            value: "IsbSubject",
            // width: "20%",
          },
          {
            text: "Tipo",
            value: "TypeInstructionText",
            // width: "20%",
          },
          {
            text: "Área",
            value: "AreAbbreviation",
            // width: "20%",
          },
          {
            text: "Duración (Min)",
            value: "IinDurationTime",
            // width: "20%",
          }, 
          {
            text: "Hora Inicio",
            value: "IInicioTime"
          },
          {
            text: "Hora Fin",
            value: "IFinTime"
          },
          {
            text: "Observaciones",
            value: "IObservation"
          },
        ],
      },
      iasConfig: {
        service: _sInstructionAttendance,
        model: {
          InsID: "int",
          IasID: "ID",
          NtpID: "int",
          PrsDocumentNumber: "string",
          NtpFullName: "string",
          WkrID: "int",
          SecStatus: "status",
        },
        headers: [
          // {
          //   text: "ID",
          //   value: "IasID",
          //   align: "end",
          //   width: "15%",
          // },
          {
            text: "Doc",
            value: "PrsDocumentNumber",
            align: "center",
             
          },
          {
            text: "Asistente",
            value: "NtpFullName",
          },
          {
            text: "Puesto",
            value: "PstName",
          },
          {
            text: "Área",
            value: "AreAbbreviation",
            // width: "30%",
          },
          // {
          //   text: "Tipo Trabajador",
          //   value: "TypeWorkerName",       
          // },
           
        ],
      },
    };
  },
  created() {
    console.log("carlos ato", this.value, this.ins);
    this.ins = this.value;
    this.initialize();
    _sInstruction.getcentercost(this.$fun.getUserID())
      .then((resp) => {
        if (resp.status == 200){
          this.itemsCenterCost = resp.data;
        }
      })
  },
  watch: {
    value(val) {
      this.ins = val;
      this.initialize();
    },
    // 'ins.InsTypeCapacitor'(val) {
    //   this.ins.NameCompanyCapacitor = []
    // }
  },
  computed: {
    filter() {
      return {
        InsID: this.ins.InsID,
      };
    },
    centerCostModel: {
      get() {
        const item = this.ins.InsCenterCost;
        if (!item) return [];
        if (typeof item === 'string') {
          try {
            const parsed = JSON.parse(item);
            return Array.isArray(parsed) ? parsed : [];
          } catch {
            return [];
          }
        }
        return Array.isArray(item) ? item : [];
      },
      set(val) {
        this.ins.InsCenterCost = val;
      }
    }
  },
  methods: {
	keyUpEnter(item, data)
	{
    if(!item){
      this.NtpName = "";
      this.NtpPerson = {};
      this.hasWorker = false;
      return;
    }
    this.NtpName = item.NtpFullName;
    this.NtpPerson = {...item};
    data.PrsDocumentNumber = item.PrsDocumentNumber;
    this.hasWorker = true;
    // console.log("sunexpert11 ",item);
		// this.NtpName = '';
		// _sPerson
		// .getNaturalPerson(item, this.$fun.getUserID())
		// .then(resp => {
		// 	if(resp.status == 200)
		// 	{

    //     console.log('sunexpert ', resp.data);
		// 		if(resp.data != null)
		// 		{
		// 			let name = resp.data.NtpPaternalSurname + ' ' + resp.data.NtpMaternalSurname + ' ' + resp.data.NtpName;
		// 			this.NtpName = name;
		// 			this.hasWorker = true;
		// 			this.NtpPerson = resp.data;
					
		// 		}
		// 		else
		// 		{
		// 			this.hasWorker = false;

    //       console.log("name", item);

          
		// 		}
		// 	}
		// })
	},

    //GENERAL
    initialize() {
      console.log("initialize", this.value);
      if (this.value.InsID > 0) {
        _sInstruction.get(this.value, this.$fun.getUserID()).then((x) => {
          this.ins.InsObservation = x.data.InsObservation;
        });
      } else
        this.ins = {
        InsDate: this.$fun.getDate(),
        InsObservation: "",
        InsID: 0,
      };

      if(this.value.InsID > 0){
        this.getphotoBD();
      }
    },
    getphotoBD() {
      console.log("getphotoBD", this.ins);
      if(this.ins.itemAnexo1){
        GenUploadFiles.getFile("routeGestionHumana", `${this.ins.itemAnexo1}`, true)
        .then(base64 => {
          this.itemAnexo1DB = base64;
        })
        .catch(error => console.error("Error al obtener imagen:", error));
      }

      if(this.ins.itemAnexo2){
        GenUploadFiles.getFile("routeGestionHumana", `${this.ins.itemAnexo2}`, true)
        .then(base64 => {
          this.itemAnexo2DB = base64;
        })
        .catch(error => console.error("Error al obtener imagen:", error));
      }
    },
    //INSTRUCTION
    insValidate() {
      let isValid;
      let message;

      isValid = this.ins.InsDate.length > 0;
      if (!isValid) message = "Registre Fecha de evento";

      if (!isValid) this.$fun.alert(message, "warning");

      if(this.ins.TypeCost == 2 && this.ins.AmountCost <= 0){
        isValid = false;
        message = "Debe registrar un costo";
      }

      if (!isValid) this.$fun.alert(message, "warning");

      return isValid;
    },

    insSave() {
      this.ins.SecStatus = 1;
      const copia = Object.assign({}, this.ins);
      if(copia.InsTypeCapacitor == 1){
        copia.InsCenterCost = '[]';
      }else{
        if(typeof this.ins.InsCenterCost != 'string'){
          copia.InsCenterCost = JSON.stringify(this.ins.InsCenterCost);
        }
      }
      console.log("Cabecera Guardar", copia);
      return _sInstruction.save(copia, this.$fun.getUserID());
    },

    insSaveCamera() {
      this.ins.SecStatus = 1;
      const copia = Object.assign({}, this.ins);
      if(copia.InsTypeCapacitor == 1){
        copia.InsCenterCost = '[]';
      }else{
        if(typeof this.ins.InsCenterCost != 'string'){
          copia.InsCenterCost = JSON.stringify(this.ins.InsCenterCost);
        }
      }
      console.log("Cabecera Guardar", copia);
      _sInstruction.save(copia, this.$fun.getUserID()).then((x) => {
        if(x.status == 200){
          this.$fun.alert("Actualizado correctamente", "success");
          this.initialize();
          this.itemAnexo1 = null;
          this.itemAnexo2 = null;
        }
      })
    },

    insSaveEntity() {
      if (this.insValidate()) {
        return this.insSave().then((x) => {
          this.$fun.alert("Actualizado correctamente", "success");
          return true;
        });
      } else {
        return Promise.resolve(false);
      }
    },

    //INSTRUCTOR
    iinSubjectFocus(event) {
      // this.$refs.tbIinSubject.focus();
    },
    iinPersonFocus(event) {
      // this.$refs.tbIinPerson.focus();
    },
    iinCallSave() {
      this.$refs.crudInstruction.save();
    },
    iinReturnPerson(value, item) {
      if (value != null) {
        item.NtpFullName = value.NtpFullName;
        item.NtpID = value.NtpID;
        item.WkrID = value.WkrID;

        if (value.NtpID > 0) this.iinCallSave();
      } else {
        item.NtpFullName = "";
        item.NtpID = 0;
        item.WkrID = 0;
      }
      this.worker = item;
    },
    iinReturnSubject(value, item) {
      value = value || {};
      console.log('iinReturnSubject', value);
      item.IsbID = value?.IsbID || 0;
      item.TypeInstruction = value.TypeInstruction;

      console.log("", value);//samir
      item.IinDurationTime = value.IsbDuration;

      // this.$nextTick(function () {
      //   this.iinPersonFocus();
      // });
    },
    iinValidate(item) {
		let isValid;
		let message;

		isValid = item?.PrsDocumentNumber.length > 0 || 0;
		if (!isValid) message = "Registre ponente/encargado";
		else {
      console.log("item",item);
			isValid = item?.IsbID > 0 || 0;
			if (!isValid) message = "Registre tema";
		}

		if (!isValid) this.$fun.alert(message, "warning");

		return isValid;
    },
    iinSaveItem(item) {
      item.IinDocumentNumber = item.PrsDocumentNumber;
      item.IinNamePerson = this.NtpName;
      item.save();
      this.uploadFile(this.IinIDSave);
      this.iinSubjectFocus();
    },
    returnObjectIin(item) {},
    iinSave(item) {
      item.InsID = this.ins.InsID;
      item.NtpID = this.NtpPerson?.NtpID || 0;
      item.WkrID = this.NtpPerson?.WkrID || 0;
      item.IinDocumentNumber = item.PrsDocumentNumber;
      item.IinNamePerson = this.NtpName;
      // if(!this.hasWorker){
      //   item.NptID = null;
      //   item.WkrID = null;
      // }
      console.log("itemmmm",item);

      if (this.iinValidate(item)) {
        // SI TIENE INSTRUCCION ENTONCES GUARDA EL DETALLE SI NO GUARDA PRIMERO LA INSTRUCCION Y LUEGO EL DETALLE
        if (item.InsID > 0) {
          this.iinSaveItem(item);
        }
        else {
          if (this.insValidate()) {
            this.insSave().then((r) => {
              this.ins.InsID = r.data.InsID;
              item.InsID = this.ins.InsID;

              //this.NtpName = "";
              if (item.InsID > 0) {
                this.iinSaveItem(item);
              }
            });
          }
        }
      }
    },
    async uploadFile(IinIDSave) {
      console.log('IinIDSave', IinIDSave);
      if(IinIDSave){
        console.log("CvCompanyCapacitor", this.fileCapacitor.CvCompanyCapacitor);
        console.log("InformeCompanyCapacitor", this.fileCapacitor.InformeCompanyCapacitor);

        let cont = 0;
        let fallos = 0;

        if (this.fileCapacitor.CvCompanyCapacitor) {
          try {
            const respImg = await GenUploadFiles.upload(this.fileCapacitor.CvCompanyCapacitor, `IinID_${IinIDSave}_CvCompanyCapacitor`, "routeGestionHumana", true);
            if(respImg.status == 200){
              cont++;
              // item.CvCompanyCapacitor = respImg.data.fileName;
            }
          } catch (error) {
            fallos ++;
            this.$fun.alert("Error al subir la foto", "warning");
            console.error("Error al subir la foto", error);
          }
        }

        if(this.fileCapacitor.InformeCompanyCapacitor){
          try {
            const respImg = await GenUploadFiles.upload(this.fileCapacitor.InformeCompanyCapacitor, `IinID_${IinIDSave}_InformeCompanyCapacitor`, "routeGestionHumana", true);
            if(respImg.status == 200){
              cont++;
              // item.InformeCompanyCapacitor = respImg.data.fileName;
            }
          } catch (error) {
            fallos ++;
            this.$fun.alert("Error al subir la foto", "warning");
            console.error("Error al subir la foto", error);
          }
        }

        if(cont > 0 && fallos == 0){
          this.$fun.alert("Anexos Guardados", "success");
        }
        else{
          this.$fun.alert("Error al subir los anexos", "warning");
        }
      }
    },
    // ATTENDANCE
    rowSelectedAttendance(items) {
      console.log("rowSelectedAttendance", items);
      if (items.length > 0) {
        this.selectedAttendance = items;
      }
      // this.$refs.tbIasPerson.focus();
    },
    iasCallSave() {
      this.$refs.crudAttendance.save();
    },
    async iasReturnPerson(value, item) {
      // console.log("hola", item)
      // console.log("value", value)
      this.AreID = null;
      this.TypeWorker = null;

      if(value != null){
        await _sInstructionAttendance.paginationInducction(value.PrsDocumentNumber, 1, this.$fun.getUserID()).then(resp => {
          if(resp.status == 200)
          {
            console.log('resp.data:', resp.data);
            this.itemsInduction = resp.data;
            if (resp.data.length >= 4) {
              this.dialogInduction = true;
            }else{
              this.dialogInduction = false;
            }
          }
        })
      }
      
      if (value == null || value.PrsID == 0) {
        //samir
        item.NtpFullName = "";
        item.NtpID = 0;
        item.IasDocumentNumber = "";
        item.WkrID = 0;
        item.CtrID = 0;
 
        // console.log("sunat", item.PrsDocumentNumber.length)
        if (item?.PrsDocumentNumber.length > 7) {
              
          _sSunarp
              .Search(item.PrsDocumentNumber, this.$fun.getUserID())
              .then(resp => {
                if(resp.status == 200)
                {
                  item.AreName = value.AreName;
                  this.AreID = value.AreID;
                  this.TypeWorker = value.TypeWorker;
                  this.selectAreName = false;
                  setTimeout(() => {
                    this.selectAreName = true;
                  }, 0);
                  console.log('repsyesta ', resp.data);
                  item.NtpFullName = resp.data.SunFatherName + ' ' + resp.data.SunMotherName + ' ' + resp.data.SunNames;
                  item.IasDocumentNumber = item.PrsDocumentNumber
                }
              })
        }
        
      }
      // if (value != null ) {
      else {
        item.NtpFullName = value.NtpFullName;
        item.NtpID = value.NtpID;
        item.IasDocumentNumber = value.PrsDocumentNumber;
        item.AreName = value.AreName;
        this.AreID = value.AreID;
        console.log('value.TypePayroll ', value);
        this.TypeWorker = value.TypeWorker;

        this.selectAreName = false;
        setTimeout(() => {
          this.selectAreName = true;
        }, 0);
        // if (value.NtpID > 0) this.iasCallSave();
      }
    },
    iasValidate(item) {
      let isValid;
      let message;

      isValid = item.NtpFullName.length > 0;
      if (!isValid) message = "Registre asistente";

      if (!isValid) this.$fun.alert(message, "warning");

      return isValid;
    },
    iasSaveItem(item) {
      item.TypeWorker = this.TypeWorker;
      item.AreID = this.AreID;
      item.save();
      // this.iasFocus();
    },

    iasSave(item) {
      item.InsID = this.ins.InsID;
      console.log("itemmmm",item);
      if (this.iasValidate(item)) {
        // SI TIENE INSTRUCCION ENTONCES GUARDA EL DETALLE SI NO GUARDA PRIMERO LA INSTRUCCION Y LUEGO EL DETALLE
        if (item.InsID > 0) this.iasSaveItem(item);
        else {
          if (this.insValidate()) {
            this.insSave().then((r) => {
              this.ins.InsID = r.data.InsID || 0;
              item.InsID = this.ins.InsID;
              if (item.InsID > 0) this.iasSaveItem(item);
            });
          }
        }
      }
    },

    async saveAttendance() {
      const selectData = [...this.selectedAttendance];
      for (let i = 0; i < selectData.length; i++) {
        selectData[i].IinID = this.itemCapacitor.IinID;
        selectData[i].IasID = null;
        // console.log(selectData[i], this.itemCapacitor.IinID);
        await _sInstructionAttendance.save(selectData[i], this.$fun.getUserID()).then(resp => {
          console.log(resp);
          if(resp.status == 200)
          {
            // this.$refs.crudAttendance.refresh();
          }
        })
      }

      // this.$refs.crudAttendance.refresh();
      this.$fun.alert("Asistencia Guardada", "success");
      this.$refs.crudAttendance.refresh();
      
      this.itemsCapacitor = [];
      _sInstructionAttendance.paginationList(this.itemCapacitor.IinID, this.$fun.getUserID()).then(resp => {
        if(resp.status == 200)
        {
          this.itemsCapacitor = resp.data;
        }
      })
    },

    rowSelected(item){
      this.itemsCapacitor = [];

      if(item !== null && item.length > 0){
        // console.log('item', item);
        this.itemCapacitor = item[0];
        this.IinIDSave = this.itemCapacitor.IinID;
        this.NtpName = this.itemCapacitor.NtpFullName;
        this.NtpPerson = {...this.itemCapacitor};
        _sInstructionAttendance.paginationList(this.itemCapacitor.IinID, this.$fun.getUserID()).then(resp => {
          if(resp.status == 200)
          {
            this.itemsCapacitor = resp.data;
          }
        })
      }else{
        this.itemCapacitor = {};
      }
    },
    calcularHoraFin(item) {
      const inicio = item.IInicioTime;
      const duracion = item.IinDurationTime;

      if (!inicio || duracion === null || duracion === '' || isNaN(Number(duracion))) {
        item.IFinTime = '';
        return;
      }

      const [hora, minuto] = inicio.split(':').map(Number);
      const fecha = new Date(0, 0, 0, hora, minuto);

      fecha.setMinutes(fecha.getMinutes() + Number(duracion));

      const horasFinal = fecha.getHours().toString().padStart(2, '0');
      const minutosFinal = fecha.getMinutes().toString().padStart(2, '0');

      item.IFinTime = `${horasFinal}:${minutosFinal}`;
    },
    openCamera() {
      this.InsIDCamera = this.ins.InsID;
      this.dialogCamera = true;
    },
    async saveEvidence(InsIDCamera) {
      if(InsIDCamera){
        console.log('InsIDCamera', InsIDCamera);
        console.log("itemAnexo1", this.itemAnexo1);
        console.log("itemAnexo2", this.itemAnexo2);

        let cont = 0;
        let fallos = 0;

        if (this.itemAnexo1) {
          try {
            const respImg = await GenUploadFiles.upload(this.itemAnexo1, `InsID_${InsIDCamera}_Anexo1`, "routeGestionHumana", true);
            if(respImg.status == 200){
              cont++;
              this.ins.itemAnexo1 = respImg.data.fileName;
            }
          } catch (error) {
            fallos ++;
            this.$fun.alert("Error al subir la foto", "warning");
            console.error("Error al subir la foto", error);
          }
        }

        if(this.itemAnexo2){
          try {
            const respImg = await GenUploadFiles.upload(this.itemAnexo2, `InsID_${InsIDCamera}_Anexo2`, "routeGestionHumana", true);
            if(respImg.status == 200){
              cont++;
              this.ins.itemAnexo2 = respImg.data.fileName;
            }
          } catch (error) {
            fallos ++;
            this.$fun.alert("Error al subir la foto", "warning");
            console.error("Error al subir la foto", error);
          }
        }

        if(cont > 0 && fallos == 0){
          this.$fun.alert("Anexos Guardados", "success");
          console.log("this.ins", this.ins);
          this.insSaveCamera();
        }
      }
    },
  },
};
</script>
